<template>
  <a-drawer width="85%" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form">
      <a-form-model-item label="协议名称">
        <a-input v-model="form.configName" disabled />
      </a-form-model-item>
      <a-form-model-item label="协议标识">
        <a-input v-model="form.configKey" disabled />
        <div class="form-tip">App 接口 group 参数：register=用户协议，privacy=隐私政策</div>
      </a-form-model-item>
      <a-tabs v-model="activeLang">
        <a-tab-pane
          v-for="item in languageFields"
          :key="item.field"
          :tab="item.label"
        >
          <editor :editorValue="item.field" v-model="form[item.field]" />
        </a-tab-pane>
      </a-tabs>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { updateProtocol, getConfig } from '@/api/system/config'
import Editor from '@/components/Editor'

const LANGUAGE_FIELDS = [
  { field: 'configValueCn', label: '简体中文 (zh_CN)' },
  { field: 'configValue', label: '繁体中文 (zh_TC)' },
  { field: 'configValueEn', label: 'English (en)' },
  { field: 'configValueBm', label: 'Français (fr)' },
  { field: 'configValueAb', label: 'العربية (ab)' },
  { field: 'configValueVi', label: 'Tiếng Việt (vi)' },
  { field: 'configValueKo', label: '한국어 (ko)' },
  { field: 'configValueIn', label: '日本語 (jp)' }
]

export default {
  name: 'CreateForm',
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      activeLang: 'configValueCn',
      languageFields: LANGUAGE_FIELDS,
      form: {
        id: null,
        configName: null,
        configKey: null,
        configValue: '',
        configValueCn: '',
        configValueEn: '',
        configValueBm: '',
        configValueIn: '',
        configValueAb: '',
        configValueVi: '',
        configValueKo: ''
      },
      open: false
    }
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.activeLang = 'configValueCn'
      this.form = {
        id: null,
        configName: null,
        configKey: null,
        configValue: '',
        configValueCn: '',
        configValueEn: '',
        configValueBm: '',
        configValueIn: '',
        configValueAb: '',
        configValueVi: '',
        configValueKo: ''
      }
    },
    handleUpdate (row) {
      this.reset()
      getConfig(row.id).then(response => {
        const data = response.data || {}
        this.form = {
          id: data.id,
          configName: data.configName,
          configKey: data.configKey,
          configValue: data.configValue || '',
          configValueCn: data.configValueCn || '',
          configValueEn: data.configValueEn || '',
          configValueBm: data.configValueBm || '',
          configValueIn: data.configValueIn || '',
          configValueAb: data.configValueAb || '',
          configValueVi: data.configValueVi || '',
          configValueKo: data.configValueKo || ''
        }
        this.open = true
        this.formTitle = '编辑协议 - ' + (data.configName || '')
      })
    },
    submitForm () {
      this.submitLoading = true
      updateProtocol(this.form).then(() => {
        this.$message.success('保存成功', 3)
        this.open = false
        this.$emit('ok')
      }).finally(() => {
        this.submitLoading = false
      })
    }
  }
}
</script>

<style scoped>
.form-tip {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  margin-top: 4px;
}
.bottom-control {
  margin-top: 24px;
}
</style>
